module.exports = __webpack_public_path__ + "static/img/intro-bg.dd02bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202304/intro-bg.png
// module id = CJdy
// module chunks = 0